import { composeValidators, email, regex, required } from "react-admin";

const wordsWithLettersDigitsAndHyphensOnly = regex(
	/^[a-zA-Z0-9\s-]+$/,
	"must include only letters, digits, and hyphens"
);
const singleSpaceSeparated = regex(
	/^\s*\S+( \S+)*\s*$/,
	"must not include consecutive white space characters"
);
const lettersAndDigitsOnly = regex(
	/^[a-zA-Z0-9]+$/,
	"must include letters and digits only"
);
const wordsWithLettersDigitsHyphensAndParens = regex(
	/^[a-zA-Z0-9\s-()]+$/,
	"must include only letters, digits, hyphens, and parentheses"
);

export const alphanumericWordsValidator = composeValidators([
	required(),
	wordsWithLettersDigitsAndHyphensOnly,
	singleSpaceSeparated,
]);

export const kidValidator = composeValidators([
	required(),
	lettersAndDigitsOnly,
]);

export const unosIdValidator = composeValidators([
	required(),
	lettersAndDigitsOnly,
]);

export const emailValidator = composeValidators([
	required(),
	email(),
	regex(/^.+@nyulangone.org$/, "must be a *@nyulangone.org address"),
]);

export const organEventNameValidator = composeValidators([
	required(),
	wordsWithLettersDigitsHyphensAndParens,
	singleSpaceSeparated,
]);
